// extracted by mini-css-extract-plugin
module.exports = {"Container":"style-module--Container--hZ9l7","Wrapper":"style-module--Wrapper--3zjL9","Lifibuoy":"style-module--Lifibuoy--3bejL","Diving":"style-module--Diving--uM6eu"};